import { cloneElement, useRef } from "react";
import FloatingMenu from "../../../../components/FloatingMenu";

type MailViewHistoryDropdownProps = {
  open: boolean;
  onClose: () => void;
  trigger: React.ReactElement;
  children: React.ReactNode;
};

export default function MailViewHistoryDropdown({
  open,
  onClose,
  trigger,
  children
}: MailViewHistoryDropdownProps) {
  const btnRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      {cloneElement(trigger, { ref: btnRef })}
      <FloatingMenu anchorRef={btnRef} open={open} onClose={onClose}>
        <div className="mail-view-history-menu" role="menu">
          {children}
        </div>
      </FloatingMenu>
    </>
  );
}
